import { Assessment } from '@mui/icons-material';
import { _id } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://familifirst.com',
  changelog: 'https://familifirst.com',
  zoneUI: 'https://familifirst.com',
  home: 'https://familifirst.com',
  freeUI: 'https://familifirst.com',
  figma: 'https://familifirst.com',
  product: {
    root: `/product`,
    details: (id) => `/product/${id}`,
  },
  // AUTH
  auth: {
    login: `${ROOTS.AUTH}/login`,
    forgotPassword: `${ROOTS.AUTH}/password-forgot`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    general: {
      booking: `${ROOTS.DASHBOARD}/booking`,
    },
    user: {
      root: `${ROOTS.DASHBOARD}/user`,
      new: `${ROOTS.DASHBOARD}/user/new`,
      list: `${ROOTS.DASHBOARD}/user/list`,
      cards: `${ROOTS.DASHBOARD}/user/cards`,
      profile: `${ROOTS.DASHBOARD}/user/profile`,
      account: `${ROOTS.DASHBOARD}/user/account`,
      edit: (id) => `${ROOTS.DASHBOARD}/user/${id}/edit`,
      demo: {
        edit: `${ROOTS.DASHBOARD}/user/${MOCK_ID}/edit`,
      },
    },
    product: {
      root: `${ROOTS.DASHBOARD}/product`,
      new: `${ROOTS.DASHBOARD}/product/new`,
      details: (id) => `${ROOTS.DASHBOARD}/product/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/product/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/product/analytics`,
    },
    cities: {
      root: `${ROOTS.DASHBOARD}/cities`,
      new: `${ROOTS.DASHBOARD}/cities/new`,
    },
    specialities: {
      root: `${ROOTS.DASHBOARD}/specialities`,
      new: `${ROOTS.DASHBOARD}/specialities/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/specialities/${id}/edit`,
    },
    hospitals: {
      root: `${ROOTS.DASHBOARD}/hospitals`,
      new: `${ROOTS.DASHBOARD}/hospitals/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/hospitals/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/hospitals/${id}/view`,
    },
    

    

    schools: {
      root: `${ROOTS.DASHBOARD}/schools`,
      new: `${ROOTS.DASHBOARD}/schools/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/schools/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/schools/${id}/view`,
    },

        grades: {
      root: `${ROOTS.DASHBOARD}/grades`,
      new: `${ROOTS.DASHBOARD}/grades/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/grades/${id}/edit`,
    },

  

    students: {
      root: `${ROOTS.DASHBOARD}/students`,
      new: `${ROOTS.DASHBOARD}/students/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/students/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/students/${id}/view`,
    },

     edutainment: {
      root: `${ROOTS.DASHBOARD}/edutainment`,
      new: `${ROOTS.DASHBOARD}/edutainment/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/edutainment/${id}/edit`,
    },
       prosperitytips: {
      root: `${ROOTS.DASHBOARD}/prosperitytips`,
      new: `${ROOTS.DASHBOARD}/prosperitytips/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/prosperitytips/${id}/edit`,
    },
      ptips: {
      root: `${ROOTS.DASHBOARD}/ptips`,
      new: `${ROOTS.DASHBOARD}/ptips/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/ptips/${id}/edit`,
    },
     stories: {
      root: `${ROOTS.DASHBOARD}/stories`,
      new: `${ROOTS.DASHBOARD}/stories/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/stories/${id}/edit`,
    },


       feeds_categories: {
      root: `${ROOTS.DASHBOARD}/feeds_categories`,
      new: `${ROOTS.DASHBOARD}/feeds_categories/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/feeds_categories/${id}/edit`,
    },
       news: {
      root: `${ROOTS.DASHBOARD}/news`,
      new: `${ROOTS.DASHBOARD}/news/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/news/${id}/edit`,
    },

    categories: {
      root: `${ROOTS.DASHBOARD}/categories`,
      new: `${ROOTS.DASHBOARD}/categories/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/categories/${id}/edit`,
    },

       calender: {
      root: `${ROOTS.DASHBOARD}/calender`,
      new: `${ROOTS.DASHBOARD}/calender/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/calender/${id}/edit`,
    },


      offlinecourse: {
      root: `${ROOTS.DASHBOARD}/offlinecourse`,
      new: `${ROOTS.DASHBOARD}/offlinecourse/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/offlinecourse/${id}/edit`,
    },

    host: {
      root: `${ROOTS.DASHBOARD}/host`,
      new: `${ROOTS.DASHBOARD}/host/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/host/${id}/edit`,
    },

    webinar: {
      root: `${ROOTS.DASHBOARD}/webinar`,
      new: `${ROOTS.DASHBOARD}/webinar/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/webinar/${id}/edit`,
    },

    onlinecourses: {
      root: `${ROOTS.DASHBOARD}/onlinecourses`,
      new: `${ROOTS.DASHBOARD}/onlinecourses/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/onlinecourses/${id}/edit`,
    },

       chapters: {
      root: `${ROOTS.DASHBOARD}/chapters`,
      new: `${ROOTS.DASHBOARD}/chapters/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/chapters/${id}/edit`,
    },


        word: {
      root: `${ROOTS.DASHBOARD}/word`,
      new: `${ROOTS.DASHBOARD}/word/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/word/${id}/edit`,
    },

    // competition: {
    //   root: `${ROOTS.DASHBOARD}/competition`,
    //   new: `${ROOTS.DASHBOARD}/competition/new`,
    //   edit: (id) => `${ROOTS.DASHBOARD}/competition/${id}/edit`,
    // },

    competition: {
      root: `${ROOTS.DASHBOARD}/competition`,
      new: `${ROOTS.DASHBOARD}/competition/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/competition/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/competition/${id}/competition_words`,
      competition_words: {
        root: (id) => `${ROOTS.DASHBOARD}/competition/${id}/competition_words`,
        // new: (id) => `${ROOTS.DASHBOARD}/competition/${id}/feeds/new`,
        // edit: (id, feedId) => `${ROOTS.DASHBOARD}/competition/${id}/feeds/${feedId}/edit`,
        // view: (id, feedId) => `${ROOTS.DASHBOARD}/competition/${id}/feeds/${feedId}/view`,
      },
    },

       gallery: {
      root: `${ROOTS.DASHBOARD}/gallery`,
      new: `${ROOTS.DASHBOARD}/gallery/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/gallery/${id}/edit`,
    },
       lessons: {
      root: `${ROOTS.DASHBOARD}/lessons`,
      new: `${ROOTS.DASHBOARD}/lessons/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/lessons/${id}/edit`,
      video: (id) => `${ROOTS.DASHBOARD}/lessons/${id}/video`,
    },

      mcqs: {
      root: `${ROOTS.DASHBOARD}/mcqs`,
      new: `${ROOTS.DASHBOARD}/mcqs/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/mcqs/${id}/edit`,
    },

    
    banner: {
      root: `${ROOTS.DASHBOARD}/banner`,
      new: `${ROOTS.DASHBOARD}/banner/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/banner/${id}/edit`,
    },

    
    events: {
      root: `${ROOTS.DASHBOARD}/events`,
      new: `${ROOTS.DASHBOARD}/events/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/events/${id}/edit`,
    },

      school_info: {
      root: `${ROOTS.DASHBOARD}/school_info`,
      new: `${ROOTS.DASHBOARD}/school_info/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/school_info/${id}/edit`,
    },

        feels: {
      root: `${ROOTS.DASHBOARD}/feels`,
      new: `${ROOTS.DASHBOARD}/feels/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/feels/${id}/edit`,
    },

       onlinecategories: {
      root: `${ROOTS.DASHBOARD}/onlinecategories`,
      new: `${ROOTS.DASHBOARD}/onlinecategories/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/onlinecategories/${id}/edit`,
    },

    onlinestoreproducts: {
      root: `${ROOTS.DASHBOARD}/onlinestoreproducts`,
      new: `${ROOTS.DASHBOARD}/onlinestoreproducts/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/onlinestoreproducts/${id}/edit`,
    },

    onlineorders: {
      root: `${ROOTS.DASHBOARD}/onlineorders`,
      new: `${ROOTS.DASHBOARD}/onlineorders/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/onlineorders/${id}/edit`,
    },

     curriculum: {
      root: `${ROOTS.DASHBOARD}/curriculum`,
      new: `${ROOTS.DASHBOARD}/curriculum/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/curriculum/${id}/edit`,
    },

    curriculum_categories: {
      root: `${ROOTS.DASHBOARD}/curriculum_categories`,
      new: `${ROOTS.DASHBOARD}/curriculum_categories/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/curriculum_categories/${id}/edit`,
    },

     curriculum_subjects: {
      root: `${ROOTS.DASHBOARD}/curriculum_subjects`,
      new: `${ROOTS.DASHBOARD}/curriculum_subjects/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/curriculum_subjects/${id}/edit`,
    },

     curriculum_lessons: {
      root: `${ROOTS.DASHBOARD}/curriculum_lessons`,
      new: `${ROOTS.DASHBOARD}/curriculum_lessons/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/curriculum_lessons/${id}/edit`,
    },

    curriculum_concept: {
      root: `${ROOTS.DASHBOARD}/curriculum_concept`,
      new: `${ROOTS.DASHBOARD}/curriculum_concept/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/curriculum_concept/${id}/edit`,
    },

    homework: {
      root: `${ROOTS.DASHBOARD}/homework`,
      new: `${ROOTS.DASHBOARD}/homework/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/homework/${id}/edit`,
    },


    
     avatar: {
      root: `${ROOTS.DASHBOARD}/avatar`,
      new: `${ROOTS.DASHBOARD}/avatar/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/avatar/${id}/edit`,
    },

     completed_homework: {
      root: `${ROOTS.DASHBOARD}/completed_homework`,
      new: `${ROOTS.DASHBOARD}/completed_homework/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/completed_homework/${id}/edit`,
    },

    
     assessment: {
      root: `${ROOTS.DASHBOARD}/assessment`,
      new: `${ROOTS.DASHBOARD}/assessment/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/assessment/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/assessment/${id}/view`,
      question_new: (id) => `${ROOTS.DASHBOARD}/assessment/${id}/question/new`,

    },
    
      assessment_question: {
      root: `${ROOTS.DASHBOARD}/assessment_question`,
      new: `${ROOTS.DASHBOARD}/assessment_question/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/assessment_question/${id}/edit`,
    },

    assessment_answers: {
      root: `${ROOTS.DASHBOARD}/assessment_answers`,
      new: `${ROOTS.DASHBOARD}/assessment_answers/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/assessment_answers/${id}/edit`,
    },

      assessment_results: {
      root: `${ROOTS.DASHBOARD}/assessment_results`,
      new: `${ROOTS.DASHBOARD}/assessment_results/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/assessment_results/${id}/edit`,
      view: (id) => `${ROOTS.DASHBOARD}/assessment_results/${id}/view`,
    },

     subject: {
      root: `${ROOTS.DASHBOARD}/subject`,
      new: `${ROOTS.DASHBOARD}/subject/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/subject/${id}/edit`,
    },

     fee: {
      root: `${ROOTS.DASHBOARD}/fee`,
      new: `${ROOTS.DASHBOARD}/fee/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/fee/${id}/edit`,
    },

      fee_structure: {
      root: `${ROOTS.DASHBOARD}/fee_structure`,
      new: `${ROOTS.DASHBOARD}/fee_structure/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/fee_structure/${id}/edit`,
    },

       broadcast: {
      root: `${ROOTS.DASHBOARD}/broadcast`,
      new: `${ROOTS.DASHBOARD}/broadcast/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/broadcast/${id}/edit`,
    },

    


































   
   



    contact: {
      root: `${ROOTS.DASHBOARD}/contact`,
      new: `${ROOTS.DASHBOARD}/contact/new`,
      subledger: (id) => `${ROOTS.DASHBOARD}/contact/${id}/subledger`,
      edit: (id) => `${ROOTS.DASHBOARD}/contact/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/contact/analytics`,
    },
    purchase: {
      root: `${ROOTS.DASHBOARD}/purchase`,
      new: `${ROOTS.DASHBOARD}/purchase/new`,
      details: (id) => `${ROOTS.DASHBOARD}/purchase/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/purchase/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/purchase/analytics`,
    },
    sales: {
      root: `${ROOTS.DASHBOARD}/sales`,
      new: `${ROOTS.DASHBOARD}/sales/new`,
      details: (id) => `${ROOTS.DASHBOARD}/sales/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/sales/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/sales/analytics`,
    },
    returns: {
      root: `${ROOTS.DASHBOARD}/returns`,
      new: `${ROOTS.DASHBOARD}/returns/new`,
      details: (id) => `${ROOTS.DASHBOARD}/returns/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/returns/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/returns/analytics`,
    },
    payments: {
      root: `${ROOTS.DASHBOARD}/payments`,
      new: `${ROOTS.DASHBOARD}/payments/new`,
      details: (id) => `${ROOTS.DASHBOARD}/payments/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/payments/${id}/edit`,
      analytics: `${ROOTS.DASHBOARD}/payments/analytics`,
    },
    godowns: {
      root: `${ROOTS.DASHBOARD}/godowns`,
      new: `${ROOTS.DASHBOARD}/godowns/new`,
      details: (id) => `${ROOTS.DASHBOARD}/godowns/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/godowns/${id}/edit`,
    },
    branches: {
      root: `${ROOTS.DASHBOARD}/branches`,
      new: `${ROOTS.DASHBOARD}/branches/new`,
      details: (id) => `${ROOTS.DASHBOARD}/branches/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/branches/${id}/edit`,
    },
    staff: {
      root: `${ROOTS.DASHBOARD}/staff`,
      new: `${ROOTS.DASHBOARD}/staff/new`,
      details: (id) => `${ROOTS.DASHBOARD}/staff/${id}`,
      edit: (id) => `${ROOTS.DASHBOARD}/staff/${id}/edit`,
    },
  },
};
